import { track } from '@eventbrite/datalayer-library';
import {
    CHECKOUT_FORM_NAME,
    CHECKOUT_PATH,
    CHECKOUT_STEP_TIME_OUT,
} from '../../../constants';
import { HeapEventName } from '../../../constants/heap';
import { isFormSubmitted } from '../../../selectors/forms';
import { trackTimerExpired } from '../../eventAnalytics';
import {
    navigateToTimeExpiredStatusPage,
    updateBackgroundTimer,
} from '../../timer';
import { updateWaitingRoomStep } from '../../waitingRoom';

export const onTimerExpired = () => (dispatch, getState) => {
    const isSubmitted = isFormSubmitted(getState(), CHECKOUT_FORM_NAME);

    dispatch(updateBackgroundTimer());

    if (isSubmitted) {
        return;
    }

    dispatch(trackTimerExpired(CHECKOUT_PATH));
    track({
        eventName: HeapEventName.timerExpired,
        eventData: {
            checkoutStep: CHECKOUT_PATH,
        },
    });
    dispatch(updateWaitingRoomStep(CHECKOUT_STEP_TIME_OUT));
    dispatch(navigateToTimeExpiredStatusPage());
};
